import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { CommentDots } from '@alefeducation/ui-elements-library-icons';
import { FeedbackIconWrapper } from './studentListStyles';

const GradeFeedback = ({
  isResponseGiven,
  isSubmitted,
  isReturned,
  onAddFeedbackClick,
  onFeedbackClick,
  attachmentRequired,
  commentRequired,
  disabled,
  pendoClassName,
}) => {
  const { t } = useTranslation();
  const canGiveFeedback =
    !isResponseGiven &&
    !isReturned &&
    ((!attachmentRequired && !commentRequired) || isSubmitted);

  return canGiveFeedback || isResponseGiven ? (
    <GradeFeedbackWrapper>
      {canGiveFeedback && (
        <FeedbackIconWrapper
          disabled={disabled}
          data-tip={disabled ? undefined : t('Message for your student')}
          data-testid="feedback-add-assignment"
          onClick={e => {
            e.stopPropagation();
            if (!disabled) {
              onAddFeedbackClick(e);
            }
          }}
          className={pendoClassName}
        >
          <CommentDots fontSize={18} />
        </FeedbackIconWrapper>
      )}
      {isResponseGiven && (
        <FeedbackIconWrapper
          disabled={disabled}
          data-tip={disabled ? undefined : t('Message for your student')}
          data-testid="feedback-assignment-icon"
          onClick={e => {
            e.stopPropagation();

            if (!disabled) {
              onFeedbackClick(e);
            }
          }}
          className={pendoClassName}
        >
          <CommentDots fontSize={18} />
        </FeedbackIconWrapper>
      )}
    </GradeFeedbackWrapper>
  ) : null;
};

GradeFeedback.propTypes = {
  isResponseGiven: PropTypes.bool.isRequired,
  isSubmitted: PropTypes.bool.isRequired,
  isReturned: PropTypes.bool.isRequired,
  onAddFeedbackClick: PropTypes.func.isRequired,
  onFeedbackClick: PropTypes.func.isRequired,
  attachmentRequired: PropTypes.bool.isRequired,
  commentRequired: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  pendoClassName: PropTypes.string,
};
GradeFeedback.defaultProps = {
  pendoClassName: '',
};

const GradeFeedbackWrapper = styled.div`
  display: inline-flex;
  align-items: center;
`;

export default GradeFeedback;
